module.exports = __webpack_public_path__ + "img/FGr_WP_A.d4a62f50.svg";